import { render, staticRenderFns } from "./_categoria.vue?vue&type=template&id=79b366fa&scoped=true"
import script from "./_categoria.vue?vue&type=script&lang=js"
export * from "./_categoria.vue?vue&type=script&lang=js"
import style0 from "./_categoria.vue?vue&type=style&index=0&id=79b366fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b366fa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsCategorySelected: require('/home/runner/work/loja/loja/components/ProductsCategorySelected.vue').default,InformationProductDescription: require('/home/runner/work/loja/loja/components/InformationProduct/Description.vue').default,InformationProductBenefits: require('/home/runner/work/loja/loja/components/InformationProduct/Benefits.vue').default,InformationProductImportantDocuments: require('/home/runner/work/loja/loja/components/InformationProduct/ImportantDocuments.vue').default})
